import { Checkbox, Chip, ICON_COLOR, IconButton } from '@zep-us/zus';
import { TrashIcon } from '@zep-us/zus/icons';
import { useTranslation } from 'next-i18next';
export const Indicator = ({
  isSaved,
  isSelected,
  onDelete
}: {
  isSaved: boolean;
  isSelected: boolean;
  onDelete?: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  if (isSaved) {
    return <Chip size="md" rounded="full" className="border border-neutral text-neutral">
        {t('ai.addQuiz.added')}
      </Chip>;
  }
  return <div className="flex items-center gap-sm" data-sentry-component="Indicator" data-sentry-source-file="Indicator.tsx">
      <IconButton onClick={e => {
      e.stopPropagation();
      onDelete?.();
    }} variant="outlined" intent="neutral" size="xs" rounded="full" data-sentry-element="IconButton" data-sentry-source-file="Indicator.tsx">
        <TrashIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="TrashIcon" data-sentry-source-file="Indicator.tsx" />
      </IconButton>
      <span aria-hidden className="h-[18px] w-px bg-gray-200" />
      <Checkbox checked={isSelected} data-sentry-element="Checkbox" data-sentry-source-file="Indicator.tsx" />
    </div>;
};